var render = function render(){var _vm=this,_c=_vm._self._c;return _c('accordion',{attrs:{"items":_vm.sectionData.children},scopedSlots:_vm._u([{key:"header",fn:function({ item }){return [_vm._v("\n    "+_vm._s(item.fields.title)+"\n  ")]}},{key:"default",fn:function({ item }){return [_c('kk-dynamic-html',{staticClass:"mb-6",attrs:{"html":item.fields.article}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }